export const getSelectLanguage = () => {
  let selectedLanguage =
    localStorage.getItem("language") !== null
      ? localStorage.getItem("language")
      : "en";
  return selectedLanguage;
};
